// extracted by mini-css-extract-plugin
export var quote = "quote-module--quote--1mGd8";
export var innerQuote = "quote-module--inner-quote--jPwNY";